export class ConfirmDialogModel {
  constructor(
    public title: string,
    public message: string,
    public yesLabel = $localize`Yes`,
    public noLabel = $localize`No`
  ) {}
}
